<template>
    <a
        :class="[
            'commom-card-contact',
            'clearfix',
            { isDisabled: cardData.status === 4 },
        ]"
        v-if="cardData"
        data-spm-data="t"
        :data-spm-content="dataSpmContent"
    >
        <div class="house-contact-container clearfix">
            <div class="left">
                <img class="sales-span" :src="cardData.fields.image" />
            </div>
            <div class="left sales-info">
                <p class="title">{{ cardData.fields.title }}</p>
                <p class="desc">{{ cardData.fields.desc }}</p>
                <div class="contact-sales" v-if="cardData.status !== 4">
                    <i class="icon icon-phone"></i>
                    <a class="contact-us" :href="phoneNum">联系电话</a>
                </div>
            </div>
            <div style="clear: both;"></div>
        </div>
        <card-bottom :data="cardData"></card-bottom>
    </a>
</template>
<script>
import cardBottom from "./../common/cardBottom.vue";
export default {
    data() {
        return {};
    },
    components: {
        cardBottom,
    },
    computed: {
        cardData() {
            return this.articleData;
        },
        phoneNum() {
            return `tel:${this.cardData.fields.phoneNum}`;
        },

        tel() {
            return `tel:${res.data[0].fields.phoneNum}`;
        },
        cardUuid() {
            return this.uuid;
        },
        dataSpmContent() {
            return `||${this.cardUuid}||`;
        },
    },

    mounted() {},
    methods: {
        callPhone() {
            this.sendAction("8643");
        },
        sendAction(acode) {
            if (
                window.sohuSpm &&
                typeof window.sohuSpm.sendAction === "function"
            ) {
                window.sohuSpm.sendAction({
                    acode: acode,
                    clkParam: `accountId:${window.cfgs.media_id}; articleId:${window.cfgs.newsId};cardId:${this.cardUuid}`,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../../less/base/mixins.less";
.commom-card-contact {
    display: inline-block;
    width: 100%;
    margin-bottom: 40px;
    .house-contact-container {
        border: 1px solid rgba(229, 229, 229, 1);
        display: flex;
        box-sizing: border-box;
        background: #ffffff;
        .left {
            padding-right: 20px;
            .sales-span {
                width: 206px;
                height: 206px;
                margin-bottom: 0;
            }
        }
        .sales-info {
            padding: 20px 20px 20px 0px;
            position: relative;
            width: 418px;
            .title {
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                margin-bottom: 12px;
                font-weight: 500;
                height: 32px; /*px*/
                line-height: 32px; /*px*/
                font-size: 32px !important; /*px*/
                color: #3c3c3d;
            }
            .desc {
                margin-bottom: 16px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                font-size: 28px !important; /*px*/
                line-height: 38px; /*px*/
                color: #a4a4a4;
            }
            .contact-sales {
                bottom: 28px;
                right: 20px;
                position: absolute;
                display: inline-flex;
                padding: 0 42px;
                background: rgba(245, 245, 245, 1);
                border-radius: 1rem; /*px*/
                justify-content: center;
                align-items: center;
                margin-left: 32px;
                height: 56px; /*px*/
                font-size: 26px !important; /*px*/
                font-family: PingFang SC;
                font-weight: bold;
                color: rgba(249, 74, 37, 1);
                text-align: center;
                .icon-phone {
                    height: 56px;
                    margin-right: 6px;
                    line-height: 56px;
                    font-size: 20px; /*px*/
                }
                .contact-us {
                    font-size: 26px !important; /*px*/
                    color: #ff0000;
                }
            }
        }
    }
}

.isDisabled {
    opacity: 0.5;
}
</style>
